import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SubscriptionPaymentService from "../../services/SubscriptionPaymentService";

const POLL_MS = 60000;

/*
 * Bell of the super admin: number of subscription payments waiting for a decision,
 * refreshed every minute. Leads to the "Paiements d'abonnement" page.
 */
const PaymentBell = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const refresh = () => {
      SubscriptionPaymentService.pendingCount()
        .then((response) => {
          const value = response.data && response.data.success;
          if (!cancelled && typeof value === "number") setCount(value);
        })
        .catch(() => {});
    };
    refresh();
    const timer = setInterval(refresh, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  return (
    <li className="nav-item">
      <Link
        className="nav-link"
        to="/paiementsAbonnement"
        title={count > 0 ? `${count} paiement(s) d'abonnement à valider` : "Paiements d'abonnement"}
      >
        <i className="far fa-bell" />
        {count > 0 && <span className="badge badge-danger navbar-badge">{count}</span>}
      </Link>
    </li>
  );
};

export default PaymentBell;
